module.exports = __webpack_public_path__ + "img/guide_01.031a926a.png";